module.exports = __webpack_public_path__ + "static/media/interactive-concept-validation.8190e28f.png";